const styles = () => ({
  filecoppy: {
    // width: 20,
    // height: 20,
    cursor: 'pointer',
    marginLeft: 5
  }
})

export default styles